import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-special-categories',
  templateUrl: './special-categories.component.html',
  styleUrls: ['./special-categories.component.scss']
})
export class SpecialCategoriesComponent implements OnInit, OnDestroy {

  @Input() specialCategories: any;
  @Input() specialStatements: any;
  @Input() selectedTeamsForModal: any;

  @Output() specialCategoriesEvent = new EventEmitter<any>();
  @Output() getStatementsEvent = new EventEmitter<any>();
  @Output() getCategoryTeams = new EventEmitter<any>();
  @Output() stepBack = new EventEmitter<any>();
  @Output() saveAndFinishLater = new EventEmitter<any>();

  openTeamModal: Subject<any> = new Subject<any>();

  specialCategoriesForm: FormGroup;

  specCategories: any;
  categoryStatements: any;
  defaultCategory: any;
  defaultCategoryTitle: string = '';
  teamsToSelectForModal: any;
  
  showTeamModal: boolean = false;
  showSpecialCategories: boolean = false;
  defaultCategoryStart: boolean = true;
  
  selectedTeams: any[] = [];
  selectedCategory: any[] = [];

  private destroy$: Subject<void> = new Subject<void>();
  private pendingModalCategoryUuid: any = null;

  statementsExtraQuestions: any[] = [];
  processExtraQuestions: any[] = [];
  categoryFromTeams: any[] = [];

  generalCategoriesMock = [
    {
      title: 'Offensive Actions',
      statements : [
        {title: 'My general health is good'}, {title: 'I have had physical pain within the last 3 months'}, {title: 'Where have you had pain? (stomach, chest, hips, knees, arms and/or wrists)'}
      ]
    },
    {
      title: 'General satisfaction',
      statements : [
        {title: 'My general health is good'}, {title: 'I have had physical pain within the last 3 months'}, {title: 'Where have you had pain? (stomach, chest, hips, knees, arms and/or wrists)'}
      ]
    },
    {
      title: 'Productivity and workload',
      statements : [
        {title: 'My general health is good'}, {title: 'I have had physical pain within the last 3 months'}, {title: 'Where have you had pain? (stomach, chest, hips, knees, arms and/or wrists)'}
      ]
    },
    {
      title: 'Immediate leader',
      statements : [
        {title: 'My general health is good'}, {title: 'I have had physical pain within the last 3 months'}, {title: 'Where have you had pain? (stomach, chest, hips, knees, arms and/or wrists)'}
      ]
    }
  ];
  defaultStatementContainer = [{
    question: {
      title: this.translate.instant('custom_poll_gen_categ_prew_statements')
    }
  }];

  constructor(private fb: FormBuilder, private ref: ChangeDetectorRef, private translate: TranslateService) {
    this.specialCategoriesForm = this.fb.group({
      category: this.fb.array([])
    });
  }

   ngOnInit(): void {
    this.processSpecialCategories();
    this.ref.detectChanges();
    this.specialStatements?.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.categoryStatements = res.statements;
      this.statementsExtraQuestions = [];
      this.processStatementsExtraQuestions(this.categoryStatements);
    });
    this.selectedTeamsForModal?.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.applyCategoryTeamsResponse(data);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  processSpecialCategories() {
    const pollCategories = this.specialCategories?.[0];
    this.specCategories = pollCategories?.categories ?? [];
    this.selectedCategory = new Array(this.specCategories.length).fill(false);
    pollCategories?.selectedCategories.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.resetSelection();
      (data?.categories ?? []).forEach((category:any) => {
        this.specCategories.forEach((categ: any) => {
          if (category.uuid === categ.category.uuid) {
            this.onChange(categ.uuid, true);
            this.restoreCategoryTeams(categ, category);
          }
        });
      });
    });

    this.defaultCategoryTitle = this.translate.instant('custom_poll_gen_categ_prew');
    this.categoryStatements = this.defaultStatementContainer;
    this.showSpecialCategories = true;
  }

  processStatementsExtraQuestions(statements: any) {
    statements.forEach((state: any, index: number) => {
      this.processExtraQuestion(state.question);
      const extraQuestions = this.removeDuplicates(this.processExtraQuestions, 'title');
      this.statementsExtraQuestions.push(extraQuestions);
      this.processExtraQuestions = [];
    });
  }

  removeDuplicates(myArray: any, prop: any) {
    return myArray.filter((obj: { [x: string]: any; }, pos: any, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  processExtraQuestion(extraQuestion: any): any {
    if (extraQuestion.extraQuestion) {
      extraQuestion.extraQuestion.extra = true;
      this.processExtraQuestions.push(extraQuestion.extraQuestion);
      return this.processExtraQuestion(extraQuestion.extraQuestion);
    } else if (extraQuestion.responses.length) {
      extraQuestion.responses.forEach((response: any) => {
        if (response.extraQuestion) {
          response.extraQuestion.extra = true;
          this.processExtraQuestions.push(response.extraQuestion);
          return this.processExtraQuestion(response.extraQuestion);
        }
      });
    }
  }

  setCategoryStatements(index: number, category: any) {
    if (this.defaultCategory !== index) {
      this.getStatementsEvent.emit({categoryUuid : category.category.uuid, index: index});
    }
    this.defaultCategory = index;
    this.defaultCategoryStart = false;
    this.defaultCategoryTitle = category?.category.title + ' ' + this.translate.instant('custom_poll_gen_categ_prew_state');
  }

  onChange(category: string, isChecked: any) {
    const categoryFromArray = <FormArray>this.specialCategoriesForm.controls['category'];
    const checked = isChecked?.target?.checked || isChecked === true;
    const categoryIndex = this.specCategories.findIndex((categ: any) => categ.uuid === category);
    if (categoryIndex !== -1) {
      this.selectedCategory[categoryIndex] = checked;
    }

    const controlIndex = categoryFromArray.controls.findIndex(x => x.value === category);
    if (checked) {
      if (controlIndex === -1) {
        categoryFromArray.push(new FormControl(category));
      }
    } else if (controlIndex !== -1) {
      categoryFromArray.removeAt(controlIndex);
    }
  }

  openTeamsModal(event: any, category: any) {
    if (event.target.checked) {
      this.pendingModalCategoryUuid = category.uuid;
      this.getCategoryTeams.emit({customPollUuid: this.specialCategories[0].pollUuid, categoryUuid: category.category.uuid});
    } else {
      this.removeCategoryTeams(category.uuid);
    }
  }

  private applyCategoryTeamsResponse(data: any) {
    const categoryUuid = this.resolveTemplateCategoryUuid(data?.categoryUuid);
    const teams = data?.teams ?? [];
    if (this.pendingModalCategoryUuid && this.pendingModalCategoryUuid === categoryUuid) {
      this.teamsToSelectForModal = {fromGeneral: false, teams: teams, categoryUuid: categoryUuid};
      this.setCategoryTeams(categoryUuid, teams.map((team: any) => team.uuid));
      this.showTeamModal = true;
      this.pendingModalCategoryUuid = null;
    } else {
      const categoryIndex = this.specCategories.findIndex((categ: any) => categ.uuid === categoryUuid);
      if (categoryIndex !== -1 && this.selectedCategory[categoryIndex]) {
        this.setCategoryTeams(categoryUuid, teams.map((team: any) => team.uuid));
      }
    }
  }

  private restoreCategoryTeams(templateCategory: any, selectedCategory: any) {
    const teams = selectedCategory.teams ?? selectedCategory._embedded?.teams;
    if (teams) {
      this.setCategoryTeams(templateCategory.uuid, teams.map((team: any) => team.uuid ?? team));
    } else {
      this.getCategoryTeams.emit({
        customPollUuid: this.specialCategories[0].pollUuid,
        categoryUuid: templateCategory.category.uuid
      });
    }
  }

  private setCategoryTeams(categoryUuid: string, teamUuids: any[]) {
    const index = this.categoryFromTeams.findIndex(x => x.categoryUuid === categoryUuid);
    if (index !== -1) {
      this.categoryFromTeams.splice(index, 1);
    }
    if (teamUuids?.length) {
      this.categoryFromTeams.push({categoryUuid: categoryUuid, teams: teamUuids});
    }
  }

  private removeCategoryTeams(categoryUuid: string) {
    this.setCategoryTeams(categoryUuid, []);
  }

  private resolveTemplateCategoryUuid(categoryUuid: string) {
    const match = this.specCategories?.find((categ: any) =>
      categ.uuid === categoryUuid || categ.category.uuid === categoryUuid);
    return match ? match.uuid : categoryUuid;
  }

  private resetSelection() {
    this.selectedCategory = new Array(this.specCategories.length).fill(false);
    (<FormArray>this.specialCategoriesForm.controls['category']).clear();
    this.categoryFromTeams = [];
  }

  setSelectedTeams(teams: any) {
    const pendingCategoryUuid = this.pendingModalCategoryUuid ?? this.teamsToSelectForModal?.categoryUuid;
    if (teams === 'empty') {
      const hasAssignedTeams = this.categoryFromTeams.some(x => x.categoryUuid === pendingCategoryUuid);
      if (pendingCategoryUuid && !hasAssignedTeams) {
        this.onChange(pendingCategoryUuid, false);
        this.removeCategoryTeams(pendingCategoryUuid);
      }
    } else if (teams !== '') {
      this.setCategoryTeams(teams.categoryUuid, teams.teams);
      this.selectedTeams = [...teams.teams];
    }
    this.pendingModalCategoryUuid = null;
    this.showTeamModal = false;
  }

  nextStep() {
    this.specialCategoriesEvent.emit({teams: this.categoryFromTeams, customPollUuid: this.specialCategories[0].pollUuid});
  }

  back() {
    this.stepBack.emit({step: 1, uuid: this.specialCategories[0].pollUuid});
  }

  saveAndFinish() {
    this.saveAndFinishLater.emit();
  }

  onOpenAccordion(event: any, index: number) {
    
  }

}
